import { render, staticRenderFns } from "./config-add-or-update.vue?vue&type=template&id=3e9d6280&"
import script from "./config-add-or-update.vue?vue&type=script&lang=js&"
export * from "./config-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports